import { Check, Dumbbell, Flag, PlayCircle } from 'lucide-react'
import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import BaseStepIndicator from './StepIndicator'
import translations from '@/translations'
import { ROUTES } from '@/types/routes.ts'

export interface StepIndicatorProps {
  className?: string
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ className }) => {
  const location = useLocation()

  const activeIndex = useMemo(() => {
    if (
      [
        ROUTES.ONBOARDING.WELCOME,
        ROUTES.ONBOARDING.LISTENING_TEST,
        ROUTES.ONBOARDING.MICROPHONE_PERMISSION,
        ROUTES.ONBOARDING.RECORDING_TEST,
        ROUTES.ONBOARDING.READY_TO_START,
        ROUTES.ONBOARDING.TIMER_TIP
      ].some((x) => x === (location.pathname || ROUTES.ONBOARDING.WELCOME))
    ) {
      return 0
    }
    if (
      [ROUTES.TESTING.ICEBREAKER].some(
        (x) => x === (location.pathname || ROUTES.ONBOARDING.WELCOME)
      )
    ) {
      return 1
    }
    if (
      [ROUTES.TESTING.TEST].some(
        (x) => x === (location.pathname || ROUTES.ONBOARDING.WELCOME)
      )
    ) {
      return 2
    }
    if (
      [ROUTES.PROCESSING, ROUTES.COMPLETED].some(
        (x) => x === (location.pathname || ROUTES.ONBOARDING.WELCOME)
      )
    ) {
      return 3
    }
    return -1
  }, [location.pathname])

  return (
    <BaseStepIndicator
      className={className}
      steps={[
        {
          icon: <Check className="h-[15px] w-[15px] lg:h-[20px] lg:w-[20px]" />,
          text: translations.steps_introduction
        },
        {
          icon: (
            <Dumbbell className="h-[15px] w-[15px] lg:h-[20px] lg:w-[20px]" />
          ),
          text: translations.steps_warmup
        },
        {
          icon: (
            <PlayCircle className="h-[15px] w-[15px] lg:h-[20px] lg:w-[20px]" />
          ),
          text: translations.steps_test
        },
        {
          icon: <Flag className="h-[15px] w-[15px] lg:h-[20px] lg:w-[20px]" />,
          text: translations.steps_result
        }
      ]}
      activeIndex={activeIndex}
    />
  )
}

export default StepIndicator
